$(document).ready(() => {
  const $el = $('[data-toggle]');

  $el.each(function () {
    const $parent = $(this);
    const open = $parent.data('toggle-show');
    const targetSelector = $parent.data('toggle');
    const $target = $(targetSelector);

    if (!open) {
      $target.toggle();
    } else {
      $parent.toggleClass('active');
    }
  });

  $el.click(function () {
    const $parent = $(this);
    const targetSelector = $parent.data('toggle');
    const $target = $(targetSelector);

    $parent.toggleClass('active');
    $target.toggle();
  });
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/toggle.js